module.exports = __webpack_public_path__ + "static/media/status-ok.29afc432.svg";